<template>
  <div class="public-content">
    <div class="breadcrumb">收片选片模板</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 5px;">详细信息</span>
      </div>
    </div>
    <div class="content">
      <el-form ref="templateForm" :rules="templateRules" :model="templateVo" label-width="180px">
        <el-form-item label="模板名称:" prop="name">
          <el-input v-model="templateVo.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="模板主题:" prop="themeId">
          <el-select v-model="templateVo.themeId" placeholder="请选择" clearable>
            <el-option v-for="item in themeList" :key="item.themeId" :label="item.themeName" :value="item.themeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否关联尺寸组:">
          <el-switch clearable v-model="templateVo.isAssociatedeSizeGroup" @change="switchChange" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)">
          </el-switch>
        </el-form-item>
        <el-form-item label="尺寸组:" v-show="templateVo.isAssociatedeSizeGroup" prop="sizeGroup">
          <el-button type="primary" round @click="$refs.selectSizeGroup.show(), Parr = [], templateVo.attribute = ''">选择尺寸组</el-button>
          <span v-show="templateVo.composeSizeGroupId" style="margin-left:10px;">已选尺寸组：{{ templateVo.groupName }}</span>
        </el-form-item>
        <el-form-item label="模板性质:" prop="attribute" v-show="templateVo.isAssociatedeSizeGroup">
          <el-radio-group v-model="templateVo.attribute" size="small" v-if="$route.query.id && parrShow">
            <el-radio-button label="1" v-if="$route.query.id && templateVo.attribute === 1">半批</el-radio-button>
            <el-radio-button label="2" v-if="$route.query.id && templateVo.attribute === 2">整批</el-radio-button>
          </el-radio-group>
          <el-radio-group v-model="templateVo.attribute" size="small" v-else>
            <el-radio-button v-for="(item, i) in Parr" :key="i" :label="item === '半批' ? 1 : 2">{{ item }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模板类型:" v-show="templateVo.isAssociatedeSizeGroup" prop="templateType">
          <el-select v-model="templateVo.templateType" placeholder="请选择" @change='selectTemplateType'>
            <el-option label="客户整本设计" value="ORDER"></el-option>
            <el-option label="本本相同" value="COMMON"></el-option>
            <el-option label="本本不同" value="PERSONAL"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="模板主图" prop="mainImage">
          <input @change="spuTerminalIndexImage($event, 'mainImage')" type="file" id="upload_B_single_img" style="display: none">
          <div class="upload_warp_img_div" v-show="mainImage.url">
            <div class="upload_img">
              <el-image :src="mainImage.url" fit='contain' style="width:100%;height:100%" :preview-src-list="[mainImage.url]">
              </el-image>
            </div>
            <div class="upload_warp_img_div_top" style="width: 170px;">
              <p class="upload_warp_img_div_del color-blue" @click="mainImage.url = ''">删除图片</p>
            </div>
          </div>
          <div class="filter" style="float:left" v-show="!mainImage.url">
            <div class="upload_warp_left" @click="fileClick('upload_B_single_img')">
              <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
            </div>
          </div>
        </el-form-item> -->
        <el-form-item label="模板页:" prop="modulees">
          <div>
            <el-button type="primary" round @click="showModuleDialog()">添加</el-button>
            <el-button type="primary" @click="$refs.addModuleDialog.show(false)" round>新建</el-button>
            <span style="color: red;margin-left: 18px;">拖动可对模板页调序</span>
          </div>
          <el-table :data="templateVo.modulees" border row-key="name" class="drag" style="width: 800px;margin: 10px 0;">
            <el-table-column prop="name" label="模板页" width="150px"></el-table-column>
            <el-table-column prop="moduleAttribute.attrName" label="收选片角色" width="150px"></el-table-column>
            <el-table-column prop="infoStr" label="模板页信息"></el-table-column>
            <el-table-column label="操作" width="150px">
              <template slot-scope="scope">
                <span class="color-blue" @click="templateVo.modulees.splice(scope.$index, 1)">移除</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button type="primary" @click="save()" round v-preventReClick>保存</el-button>
    </div>
    <!-- 添加 -->
    <el-dialog :close-on-click-modal="false" title="模板页" :visible.sync="selectModuleDialog" width="800px">
      <div class="selectInfo">
        <span>模板页:</span>
        <el-input v-model="searchModuleVo.name"></el-input>
        <span v-show="templateVo.isAssociatedeSizeGroup" style="margin-right: 30px">尺寸组:{{ templateVo.groupName }}</span>
        <el-button type="primary" @click="getModuleList()" round>搜索</el-button>
        <el-button type="primary" @click="$refs.addModuleDialog.show(false)" round>新建</el-button>
        <div style="margin-left: 10px;margin-top: 20px" v-show="templateVo.attribute"> 模板性质:{{ templateVo.attribute == 1 ? '半批' : templateVo.attribute == 2 ? '整批' : '未定义' }} </div>
      </div>
      <el-table ref="multipleTable" border :data="moduleList" :row-key="getRowKeys" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>openSave <el-table-column label="模板页" prop="name" width="100px"></el-table-column>
        <el-table-column label="收选片角色" prop="moduleAttribute.attrName" width="100px"></el-table-column>
        <el-table-column label="尺寸" prop="composeSize.sizeName" width="100px"></el-table-column>
        <el-table-column label="模板性质" prop="attribute">
          <template slot-scope="scope"> {{ scope.row.attribute === 1 ? '半批' : scope.row.attribute === 2 ? '整批' : '' }} </template>
        </el-table-column>
        <el-table-column label="页面类型">
          <template slot-scope="scope"> {{ scope.row.composeSize ? $store.state.pms.pageType[scope.row.composeSize.pageTypeCode] : '' }} </template>
        </el-table-column>
        <el-table-column label="模板页信息" prop="infoStr"></el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <span class="color-blue" @click="$refs.checkDesign.show(scope.row.moduleId)">查看设计版</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页数据 -->
      <v-pagination class="v-pagination" @changePage="changePage" :queryInfo="moduleQueryInfo"></v-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="selectModule()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新建模板页 -->
    <el-dialog :close-on-click-modal="false" :title="isEdit ? '编辑模板页' : '新建模板页'" :visible.sync="addMustDialog" @closed="addModuleClosed" width="750px">
      <el-form ref="addModuleForm" :model="addModuleVo" :rules="addMofuleRules" label-width="100px">
        <el-form-item label="模板页名称:" prop="name">
          <el-input v-model="addModuleVo.name"></el-input>
        </el-form-item>
        <el-form-item label="模板页信息:" prop="list">
          <div>
            <el-select clearable v-model="selectModuleInfo" value-key="infoId" filterable placeholder="请输入业务名称">
              <el-option v-for="item in moduleInfoList" :key="item.infoId" :label="item.name" :value="item"></el-option>
            </el-select>
            <el-button type="primary" style="margin-left:20px;" round @click="moduleInfoToList">添加</el-button>
            <el-button type="primary" @click="addModuleInfoDialog = true" round>新建</el-button>
          </div>
          <el-table :data="selectModuleInfoList" border style="width: 500px;margin: 10px 0;">
            <el-table-column prop="name" label="模板页信息"></el-table-column>
            <el-table-column prop="infoType" label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.infoType === 'TEXT'">文本</span>
                <span v-if="scope.row.infoType === 'IMAGE'">图片</span>
              </template>
            </el-table-column>
            <el-table-column prop="infoValue" label="数量/长度限制" width="200px">
              <template slot-scope="scope">
                <div class="infoValue" v-if="scope.row.infoType === 'TEXT'"> 文本长度： <el-input v-model="scope.row.textValue"></el-input>
                </div>
                <div class="infoValue" v-if="scope.row.infoType === 'IMAGE'"> 数量: <el-input v-model="scope.row.imageValueStart"></el-input> - <el-input v-model="scope.row.imageValueEnd"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span class="color-blue" @click="moduleInfoRemoveList(scope)">移除</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addModule">确 定</el-button>
      </span>
      <el-dialog :close-on-click-modal="false" width="600px" title="新建模板页信息" :visible.sync="addModuleInfoDialog" @closed="addModuleInfoClosed" append-to-body>
        <el-form ref="addModuleInfoForm" :model="addModuleInfoVo" :rules="addModuleInfoRules" label-width="100px">
          <el-form-item label="信息名称:" prop="name">
            <el-input v-model="addModuleInfoVo.name"></el-input>
          </el-form-item>
          <el-form-item label="信息类型:" prop="infoType">
            <el-select v-model="addModuleInfoVo.infoType" placeholder="请选择">
              <el-option label="文本" value="TEXT"></el-option>
              <el-option label="图片" value="IMAGE"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="长度限制:" prop="value">
            <el-input v-model="addModuleInfoVo.textValue" v-show="addModuleInfoVo.infoType === 'TEXT'"></el-input>
            <div v-show="addModuleInfoVo.infoType === 'IMAGE'">
              <el-input style="margin:0px;" v-model.number="addModuleInfoVo.imageValueStart"></el-input> — <el-input v-model.number="addModuleInfoVo.imageValueEnd"></el-input>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addModuleInfo()">确 定</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <addModuleDialog ref="addModuleDialog" @success="getModuleList"></addModuleDialog>
    <selectSizeGroup ref="selectSizeGroup" @selected='selected' />
    <checkDesign ref="checkDesign" />
  </div>
</template>

<script>
import checkDesign from '../module/checkDesign.vue'
import selectSizeGroup from './selectSizeGroup.vue'
import Sortable from 'sortablejs'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
import addModuleDialog from '../components/addModuleDialog.vue'
import VPagination from '@/components/Pagination/index'
import { moduleInfoAdd, moduleInfoPage, moduleAdd, modulePage, themeList, moduleUpdate, templateAdd, templateQueryById, templateUpdate } from '@/api/auxx.js'
export default {
  components: {
    addModuleDialog, selectSizeGroup, checkDesign, VPagination
  },
  data () {
    var value = (rule, value, callback) => {
      if (this.addModuleInfoVo.infoType === 'TEXT' && this.addModuleInfoVo.textValue && !/[^\d]/g.test(this.addModuleInfoVo.textValue)) {
        callback()
      } else if (this.addModuleInfoVo.infoType === 'IMAGE' && this.addModuleInfoVo.imageValueStart && !/[^\d]/g.test(this.addModuleInfoVo.imageValueStart) && this.addModuleInfoVo.imageValueEnd && !/[^\d]/g.test(this.addModuleInfoVo.imageValueEnd)) {
        callback()
      } else {
        callback(new Error('请输入长度限制，格式为整数'))
      }
    }
    var list = (rule, value, callback) => {
      if (this.selectModuleInfoList.length === 0) {
        callback(new Error('请选择模板页信息'))
      } else {
        callback()
      }
    }
    var modulees = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请选择模板页'))
      } else {
        callback()
      }
    }

    var sizeGroup = (rule, value, callback) => {
      if (this.templateVo.isAssociatedeSizeGroup && !this.templateVo.composeSizeGroupId) {
        callback(new Error('请选择尺寸组'))
      } else {
        callback()
      }
    }
    var attribute = (rule, value, callback) => {
      if (this.templateVo.isAssociatedeSizeGroup && !this.templateVo.attribute) {
        callback(new Error('请选择模板性质'))
      } else {
        callback()
      }
    }
    var templateType = (rule, value, callback) => {
      if (this.templateVo.isAssociatedeSizeGroup && !this.templateVo.templateType) {
        callback(new Error('请选择模板类型'))
      } else {
        callback()
      }
    }

    return {
      mainImage: {
        url: ''
      },
      Parr: [],
      parrShow: true,
      themeList: [],
      isEdit: false,
      templateVo: {
        isAssociatedeSizeGroup: false,
        composeSizeGroupId: '',
        groupName: '',
        attachType: 'HQ',
        modulees: [],
        name: '',
        themeId: '',
        attribute: ''
      },
      culShow: false,
      addModuleVo: {
        name: ''
      },
      searchModuleVo: {
        name: ''
      },
      moduleInfoQueryInfo: {
        total: 0,
        pageSize: 10000,
        pageNum: 1000
      },
      selectModuleInfo: null,
      selectModuleInfoList: [],
      moduleInfoList: [],
      addModuleInfoVo: {
        infoType: 'TEXT',
        imageValueStart: '',
        imageValueEnd: '',
        textValue: '',
        name: ''
      },
      moduleQueryInfo: {
        total: 0,
        pageNum: 1, // 当前显示第几页
        pageSize: 10 // 每一页显示条数
      },
      moduleList: [],
      selectModuleList: [],
      selectModuleDialog: false,
      addModuleInfoDialog: false,
      addMustDialog: false,
      tableData: [{}],
      addRoleVo: {

      },
      form: {},
      addMofuleRules: {
        name: [
          { required: true, message: '请输入模板页名称', trigger: 'blur' },
          { max: 20, message: '长度20个字以内', trigger: 'blur' }
        ],
        list: [
          { validator: list, trigger: 'blur' }
        ]
      },
      addModuleInfoRules: {
        name: [
          { required: true, message: '请输入模板页信息', trigger: 'blur' },
          { max: 20, message: '长度20个字以内', trigger: 'blur' }
        ],
        infoType: [
          { required: true, message: '请选择信息类型', trigger: 'change' }
        ],
        value: [
          { validator: value, trigger: 'blur' }
        ]
      },
      templateRules: {
        name: [
          { required: true, message: '请输入模板名称', trigger: 'blur' },
          { max: 20, message: '长度20个字以内', trigger: 'blur' }
        ],
        themeId: [
          { required: true, message: '请选择模板主题', trigger: 'change' }
        ],
        modulees: [
          { required: true, validator: modulees, trigger: 'blur' }
        ],
        sizeGroup: [
          { validator: sizeGroup, trigger: 'blur' }
        ],
        attribute: [
          { validator: attribute, trigger: 'blur' }
        ],
        templateType: [
          { validator: templateType, trigger: 'change' }
        ]
      }
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    this.getThemeList()
    if (this.$route.query.id) {
      this.getTemplateVo()
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
    let el = document.getElementsByClassName('drag')[0].querySelectorAll('tbody')[0]
    console.log(el)
    Sortable.create(el, {
      disabled: false, // 是否开启拖拽
      ghostClass: 'sortable-ghost', // 拖拽样式
      animation: 150, // 拖拽延时，效果更好看
      group: { // 是否开启跨表拖拽
        pull: false,
        put: false
      },
      onEnd: (e) => { // 这里主要进行数据的处理，拖拽实际并不会改变绑定数据的顺序，这里需要自己做数据的顺序更改
        console.log(e)
        let list = this.templateVo.modulees
        list.splice(e.newIndex, 0, list.splice(e.oldIndex, 1)[0])
        console.log(list)
        this.$nextTick(_ => {
          this.templateVo.modulees = list
        })
      }
    })
  },
  methods: {
    fileClick (id) {
      document.getElementById('upload_B_single_img').click()
    },
    spuTerminalIndexImage (e, listName) {
      console.log('e.target.files', e.target.files)
      let files = e.target.files
      for (let i = 0; i < files.length; i++) {
        uploadWebImg(files[i], this.$store.state.awsSdk.product.s3)
          .then(res => {
            if (listName === 'mainImage') {
              this.mainImage = {
                url: res,
                mimetype: files[i].type,
                sortOrder: 0
              }
            }
            // this.$refs.formRef.validateField(listName)
          })
      }
    },
    showModuleDialog () {
      if (this.templateVo.isAssociatedeSizeGroup && !this.templateVo.composeSizeGroupId) {
        this.$message.error('请选择尺寸组')
        return
      }
      this.getModuleList()
      this.selectModuleDialog = true
    },
    selectTemplateType () {
      this.templateVo.modulees = []
    },
    change (val) {
      this.culShow = val
    },
    selected (info) {
      console.log(info, info.groupName, info.id)
      this.templateVo.composeSizeGroupId = info.id
      this.templateVo.groupName = info.groupName
      info.sizeList.forEach(item => {
        if (item.spuPageName.templateProperty.indexOf(',') === -1) {
          this.Parr.push(item.spuPageName.templateProperty)
        } else {
          item.spuPageName.templateProperty.split(',').forEach(i => {
            this.Parr.push(i)
          })
        }
      })
      this.parrShow = false
      this.Parr = [...new Set(this.Parr)]
      console.log('ParrParrParr', this.Parr)
      if (this.Parr.length === 1 && this.Parr.includes('整批')) this.templateVo.attribute = 2
      else if (this.Parr.length === 1 && !this.Parr.includes('整批')) this.templateVo.attribute = 1
    },
    getThemeList () {
      themeList()
        .then(res => {
          if (res.data.success) {
            this.themeList = res.data.data
          }
        })
    },
    getTemplateVo () {
      templateQueryById(this.$route.query.id)
        .then(res => {
          if (res.data.success) {
            let Vo = res.data.data
            if (Vo.mainImage) {
              this.mainImage = {
                url: Vo.mainImage,
                mimetype: 'image/jpeg',
                sortOrder: 0
              }
            }
            Vo.modulees = []
            Vo.templateModuleXrefs.forEach(module => {
              let str = ''
              module.module.moduleInfoXrefs.forEach(info => {
                if (info.infoType === 'TEXT') {
                  str += info.refInfo.name + '：文本长度' + info.infoValue + ' ; '
                } else if (info.infoType === 'IMAGE') {
                  str += info.refInfo.name + '：照片数量' + info.infoValue + ' ; '
                }
              })
              module.module.infoStr = str

              Vo.modulees[module.sorting - 1] = module.module
            })
            this.templateVo = Vo
            if (Vo.composeSizeGroup) {
              this.templateVo.composeSizeGroupId = Vo.composeSizeGroup.composeSizeGroupId
              this.templateVo.groupName = Vo.composeSizeGroup.groupName
              console.log(this.templateVo.composeSizeGroupId, this.templateVo.groupName)
            }
          }
        })
    },
    save () {
      // if (!this.mainImage.url) {
      //   this.$message.error('请上传模板主图')
      //   return
      // }
      this.$refs.templateForm.validate((valid) => {
        if (!valid) {
          return
        }
        let Vo = {
          attachType: 'HQ',
          isAssociatedeSizeGroup: this.templateVo.isAssociatedeSizeGroup,
          composeSizeGroupId: this.templateVo.isAssociatedeSizeGroup ? this.templateVo.composeSizeGroupId : '',
          groupName: this.templateVo.isAssociatedeSizeGroup ? this.templateVo.groupName : '',
          templateType: this.templateVo.isAssociatedeSizeGroup ? this.templateVo.templateType : '',
          modulees: [],
          attribute: this.templateVo.attribute * 1,
          name: this.templateVo.name,
          themeId: this.templateVo.themeId
          // mainImage: this.mainImage.url
        }
        this.templateVo.modulees.forEach((item, index) => {
          Vo.modulees.push({
            moduleId: item.moduleId,
            sorting: index + 1
          })
        })
        if (this.$route.query.id) {
          Vo.templateId = this.$route.query.id
          templateUpdate(Vo)
            .then(res => {
              if (res.data.success) {
                this.$message.success('编辑成功')
                this.$router.go(-1)
              }
            })
        } else {
          templateAdd(Vo)
            .then(res => {
              if (res.data.success) {
                this.$message.success('创建成功')
                this.$router.go(-1)
              }
            })
        }
      })
    },
    editModule (scope) {
      let list = scope.row.moduleInfoXrefs

      list.forEach(info => {
        info.name = info.refInfo.name
        if (info.infoType === 'TEXT') {
          info.textValue = info.infoValue
        } else if (info.infoType === 'IMAGE') {
          info.imageValueStart = info.infoValue.split('-')[0]
          info.imageValueEnd = info.infoValue.split('-')[1]
        }
      })

      this.selectModuleInfoList = list

      this.addModuleVo = JSON.parse(JSON.stringify(scope.row))
      this.getModuleInfoList()
      this.isEdit = true
      this.addMustDialog = true
    },

    getRowKeys (row) {
      return row.moduleId
    },

    handleSelectionChange (val) {
      this.selectModuleList = val
    },
    switchChange () {
      this.templateVo.modulees = []
    },
    selectModule () {
      if (this.templateVo.templateType === 'COMMON') {
        let arr = []
        let a = false
        this.selectModuleList.forEach(item => {
          if (item.composeSize.pageTypeCode === 'COVER') {
            if (!item.moduleAttribute.isAdmin) {
              a = true
            } else {
              arr.push(item)
            }
          }
        })
        if (a) {
          this.$message.error('模版类型为本本相同，封面仅可关联管理员')
          return
        }
        if (arr.length > 1) {
          this.$message.error(`当前封面已选择${arr.length}个，应为1个`)
          return
        }
      }
      if (this.templateVo.templateType === 'PERSONAL') {
        let Array = []
        let arr = []
        this.selectModuleList.forEach(item => {
          if (item.composeSize.pageTypeCode === 'COVER') {
            Array.push(item)
          }
          if (item.moduleAttribute.isAdmin === false) {
            arr.push(item.moduleAttribute.attrId)
          }
        })
        arr = [...new Set(arr)]
        if (arr.length > 1) {
          this.$message.error('模版页类型为本本不同，收选片角色除管理员外仅可添加一种角色')
          return
        }
        if (Array.length > 1) {
          this.$message.error(`当前封面已选择${Array.length}个，应为1个`)
          return
        }
      }
      if (this.templateVo.templateType === 'ORDER') {
        // 客户整本设计
        let Array = []
        let arr = []
        let isAdminItem = []
        this.selectModuleList.forEach(item => {
          if (item.composeSize.pageTypeCode === 'COVER') {
            Array.push(item)
          }
          if (item.moduleAttribute.isAdmin) {
            isAdminItem.push(item)
          } else {
            arr.push(item.moduleAttribute.attrId)
          }
        })
        arr = [...new Set(arr)]
        if (arr.length > 1 || isAdminItem.length > 0) {
          this.$message.error('模版页类型为客户整本设计，收选片角色仅可添加一种非管理员角色')
          return
        }
        if (Array.length > 1) {
          this.$message.error(`当前封面已选择${Array.length}个，应为1个`)
          return
        }
      }
      this.templateVo.modulees = this.selectModuleList
      this.selectModuleDialog = false
      this.$refs.templateForm.validateField('modulees')
    },
    getModuleList () {
      modulePage({
        vo: { name: this.searchModuleVo.name, composeSizeGroupId: this.templateVo.isAssociatedeSizeGroup ? this.templateVo.composeSizeGroupId : '', attribute: this.templateVo.attribute },
        params: { page: this.moduleQueryInfo.pageNum - 1, size: this.moduleQueryInfo.pageSize }
      })
        .then(res => {
          if (res.data.success) {
            this.moduleQueryInfo.total = res.data.data.total
            this.moduleInfoQueryInfo.total = res.data.data.total
            let list = res.data.data.content
            list.forEach(module => {
              let str = ''
              module.moduleInfoXrefs.forEach(info => {
                if (info.infoType === 'TEXT') {
                  str += info.refInfo.name + '：文本长度' + info.infoValue + ' ; '
                } else if (info.infoType === 'IMAGE') {
                  str += info.refInfo.name + '：照片数量' + info.infoValue + ' ; '
                }
              })
              module.infoStr = str
            })
            this.moduleList = [...list]
          }
        })
    },

    // 模板页分页
    changePage (info) {
      this.moduleQueryInfo.pageNum = info.pageNum
      console.log(info)
      this.getModuleList()
    },

    addModuleClosed () {
      this.addModuleVo.name = ''
      this.selectModuleInfoList.length = 0
      this.$refs.addModuleForm.resetFields()
    },
    addModule () {
      this.$refs.addModuleForm.validate((valid) => {
        if (!valid) {
          return
        }

        let addModuleVo = {
          attachType: 'HQ',
          moduleInfoVos: [],
          name: this.addModuleVo.name
        }

        if (
          this.selectModuleInfoList.some(item => {
            let lock = false
            if (item.infoType === 'TEXT' && /[^\d]/g.test(item.textValue)) {
              lock = true
            } else if (item.infoType === 'IMAGE' && item.imageValueStart && /[^\d]/g.test(item.imageValueStart) && item.imageValueEnd && /[^\d]/g.test(item.imageValueEnd)) {
              lock = true
            }
            return lock
          })
        ) {
          this.$message.error('模板页信息限制数据有误，应为非负整数，请检查后重试')
          return
        }

        addModuleVo.moduleInfoVos = this.selectModuleInfoList.reduce((list, item) => {
          let infoValue = ''
          if (item.infoType === 'TEXT') {
            infoValue = item.textValue
          } else if (item.infoType === 'IMAGE') {
            infoValue = item.imageValueStart + '-' + item.imageValueEnd
          }

          let obj = {
            defaultChange: infoValue !== item.infoValue,
            infoId: item.infoId,
            infoType: item.infoType,
            infoValue
          }
          list.push(obj)
          return list
        }, [])

        if (this.isEdit) {
          addModuleVo.moduleId = this.addModuleVo.moduleId
          moduleUpdate(addModuleVo)
            .then(res => {
              if (res.data.success) {
                this.$message.success('修改成功')
                this.addMustDialog = false
                this.getModuleList()
              }
            })
        } else {
          moduleAdd(addModuleVo)
            .then(res => {
              if (res.data.success) {
                this.$message.success('新建成功')
                this.addMustDialog = false
              }
            })
        }
      })
    },
    moduleInfoRemoveList (scope) {
      this.selectModuleInfoList.splice(scope.$index, 1)
    },
    moduleInfoToList () {
      if (
        this.selectModuleInfo &&
        !this.selectModuleInfoList.some(item => item.infoId === this.selectModuleInfo.infoId)
      ) {
        let obj = JSON.parse(JSON.stringify(this.selectModuleInfo))
        if (obj.infoType === 'TEXT') {
          obj.textValue = obj.infoValue
        } else if (obj.infoType === 'IMAGE') {
          obj.imageValueStart = obj.infoValue.split('-')[0]
          obj.imageValueEnd = obj.infoValue.split('-')[1]
        }
        this.selectModuleInfoList.push(obj)
        this.$refs.addModuleForm.validateField('list')
      }
    },
    getModuleInfoList (val) {
      moduleInfoPage({
        params: { page: this.moduleInfoQueryInfo.pageNum - 1, size: this.moduleInfoQueryInfo.pageSize },
        vo: { name: val }
      })
        .then(res => {
          if (res.data.success) {
            this.moduleInfoList = res.data.data.content
          }
        })
    },
    addModuleInfoClosed () {
      this.addModuleInfoVo.infoType = 'TEXT'
      this.addModuleInfoVo.imageValueStart = ''
      this.addModuleInfoVo.imageValueEnd = ''
      this.addModuleInfoVo.textValue = ''
      this.addModuleInfoVo.name = ''
      this.$refs.addModuleInfoForm.resetFields()
    },
    addModuleInfo () {
      this.$refs.addModuleInfoForm.validate((valid) => {
        if (!valid) {
          return
        }
        let vo = {
          attachType: 'HQ',
          infoType: this.addModuleInfoVo.infoType,
          infoValue: '',
          name: this.addModuleInfoVo.name
        }
        if (vo.infoType === 'TEXT') {
          vo.infoValue = this.addModuleInfoVo.textValue
        } else if (vo.infoType === 'IMAGE') {
          vo.infoValue = this.addModuleInfoVo.imageValueStart + '-' + this.addModuleInfoVo.imageValueEnd
        }
        moduleInfoAdd(vo)
          .then(res => {
            if (res.data.success) {
              this.getModuleInfoList()
              this.$message.success('新建成功')
              this.addModuleInfoDialog = false
            }
          })
      })
    }
  }
}
</script>

<style lang="less" scoped>
@deep: ~">>>";

.infoValue {
  @{deep} .el-input {
    width: 40px;

    input {
      padding: 0 2px;
      text-align: center;
    }
  }
}

.selectInfo {
  margin-bottom: 10px;

  span {
    margin-left: 10px;
  }

  @{deep} .el-input {
    width: 150px;
    margin: 0 20px;
  }
}

.right-main {
  padding: 10px;
}

.add-category {
  justify-content: space-between;
}

.keywords {
  display: flex;
  justify-content: space-around;
  // width: 750px;
  align-items: center;

  .el-input {
    width: 180px;
  }
}

.content {
  padding: 20px;
}

.footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px 100px;
}

/deep/ .el-radio-button__inner:hover {
  color: #1473e6;
}

/deep/.el-radio-button,
/deep/.el-radio-button__inner {
  width: 60px !important;
  border-radius: 20px !important;
  box-shadow: none !important;
  margin-right: 10px;
}

.upload_warp_img_div {
  margin: 5px;
  border: 1px solid #D2D2D2;
  width: 170px;

  .upload_img {
    width: 170px;
    height: 170px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: hidden;

    img {
      width: 100%;
    }
  }

  .upload_warp_img_div_top {
    display: flex;
    width: 100%;
    align-items: center;
    background: #f9fafc;
    justify-content: center;
    line-height: 36px;
    border-top: 1px solid #ececec;
  }

  .upload_warp_img_div_del {
    padding-left: 10px;
  }

}

.upload_warp_left {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 207px;
  border: 1px solid #666;
  cursor: pointer;
  flex-flow: column;

  i {
    margin-bottom: 10px;
    // display: block;
    // width: 100%;
    // height: 100%;
  }

  div {
    color: #666;
    font-size: 16px;
  }
}
</style>
